<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card>
          <v-tabs>
            <v-tab>
              {{ $t("language.leaveapplication") }}
              <v-chip
                v-if="$store.getters.inboxcount.leave > 0"
                x-small
                class="ma-2"
                color="red"
                text-color="white"
                >{{ $store.getters.inboxcount.leave }}</v-chip
              >
            </v-tab>
            <v-tab>
              {{ $t("language.officialvisitapplication") }}
              <v-chip
                v-if="$store.getters.inboxcount.officialvisit > 0"
                x-small
                class="ma-2"
                color="red"
                text-color="white"
                >{{ $store.getters.inboxcount.officialvisit }}</v-chip
              >
            </v-tab>
            <v-tab>
              {{ $t("language.lateinearlyoutapplication") }}
              <v-chip
                v-if="$store.getters.inboxcount.lateinearlyout > 0"
                x-small
                class="ma-2"
                color="red"
                text-color="white"
                >{{ $store.getters.inboxcount.lateinearlyout }}</v-chip
              >
            </v-tab>
            <v-tab v-if="$store.getters.settings.enableattendanceapplication">
              {{ $t("language.attendanceapplication") }}
              <v-chip
                v-if="$store.getters.inboxcount.attendance > 0"
                x-small
                class="ma-2"
                color="red"
                text-color="white"
                >{{ $store.getters.inboxcount.attendance }}</v-chip
              >
            </v-tab>
            <v-tab-item>
              <v-data-table
                :headers="leaveapplicationgrid.headers"
                :items="leaveapplicationgrid.body"
                :options.sync="leaveapplicationgrid.options"
                :server-items-length="leaveapplicationgrid.total"
                :loading="leaveapplicationgrid.loading"
                :footer-props="grid.footerProps"
                :items-per-page="grid.itemsperpage"
                class="elevation-2"
              >
                <template v-slot:header.person>
                  <span>{{ $t("language.person") }}</span>
                </template>
                <template v-slot:header.fromdate>
                  <span>{{ $t("language.fromdate") }}</span>
                </template>
                <template v-slot:header.todate>
                  <span>{{ $t("language.todate") }}</span>
                </template>
                <template v-slot:header.days>
                  <span>{{ $t("language.days") }}</span>
                </template>
                <template v-slot:header.approver>
                  <span>{{ $t("language.approver") }}</span>
                </template>
                <template v-slot:header.recommender>
                  <span>{{ $t("language.recommender") }}</span>
                </template>
                <template v-slot:header.reason>
                  <span>{{ $t("language.reason") }}</span>
                </template>
                <template v-slot:item.fromdate="{ item }">
                  {{ getDefaultDate(item.fromdate) }}
                </template>
                <template v-slot:item.todate="{ item }">
                  {{ getDefaultDate(item.todate) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        leaveapplicationgrid,
                        item.id,
                        'leave',
                        'approve'
                      )
                    "
                    color="success"
                    >{{ $t("language.approve") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        leaveapplicationgrid,
                        item.id,
                        'leave',
                        'reject'
                      )
                    "
                    color="error"
                    >{{ $t("language.reject") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'APPROVED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.approved") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'REJECTED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.rejected") }}</v-chip
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        leaveapplicationgrid,
                        item.id,
                        'leave',
                        'recommend'
                      )
                    "
                    color="success"
                    >{{ $t("language.recommend") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        leaveapplicationgrid,
                        item.id,
                        'leave',
                        'decline'
                      )
                    "
                    color="error"
                    >{{ $t("language.decline") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'RECOMMENDED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.recommended") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'DECLINED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.declined") }}</v-chip
                  >
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="officialvisitapplicationgrid.headers"
                :items="officialvisitapplicationgrid.body"
                :options.sync="officialvisitapplicationgrid.options"
                :server-items-length="officialvisitapplicationgrid.total"
                :loading="officialvisitapplicationgrid.loading"
                :footer-props="grid.footerProps"
                :items-per-page="grid.itemsperpage"
                class="elevation-2"
              >
                <template v-slot:header.person>
                  <span>{{ $t("language.person") }}</span>
                </template>
                <template v-slot:header.fromdate>
                  <span>{{ $t("language.fromdate") }}</span>
                </template>
                <template v-slot:header.todate>
                  <span>{{ $t("language.todate") }}</span>
                </template>
                <template v-slot:header.days>
                  <span>{{ $t("language.days") }}</span>
                </template>
                <template v-slot:header.approver>
                  <span>{{ $t("language.approver") }}</span>
                </template>
                <template v-slot:header.recommender>
                  <span>{{ $t("language.recommender") }}</span>
                </template>
                <template v-slot:header.reason>
                  <span>{{ $t("language.reason") }}</span>
                </template>
                <template v-slot:header.place>
                  <span>{{ $t("language.place") }}</span>
                </template>
                <template v-slot:item.fromdate="{ item }">
                  {{ getDefaultDate(item.fromdate) }}
                </template>
                <template v-slot:item.todate="{ item }">
                  {{ getDefaultDate(item.todate) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        officialvisitapplicationgrid,
                        item.id,
                        'officialvisit',
                        'approve'
                      )
                    "
                    color="success"
                    >{{ $t("language.approve") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        officialvisitapplicationgrid,
                        item.id,
                        'officialvisit',
                        'reject'
                      )
                    "
                    color="error"
                    >{{ $t("language.reject") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'APPROVED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.approved") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'REJECTED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.rejected") }}</v-chip
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        officialvisitapplicationgrid,
                        item.id,
                        'officialvisit',
                        'recommend'
                      )
                    "
                    color="success"
                    >{{ $t("language.recommend") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        officialvisitapplicationgrid,
                        item.id,
                        'officialvisit',
                        'decline'
                      )
                    "
                    color="error"
                    >{{ $t("language.decline") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'RECOMMENDED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.recommended") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'DECLINED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.declined") }}</v-chip
                  >
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="lateinearlyoutapplicationgrid.headers"
                :items="lateinearlyoutapplicationgrid.body"
                :options.sync="lateinearlyoutapplicationgrid.options"
                :server-items-length="lateinearlyoutapplicationgrid.total"
                :loading="lateinearlyoutapplicationgrid.loading"
                :footer-props="grid.footerProps"
                :items-per-page="grid.itemsperpage"
                class="elevation-2"
              >
                <template v-slot:header.person>
                  <span>{{ $t("language.person") }}</span>
                </template>
                <template v-slot:header.date>
                  <span>{{ $t("language.date") }}</span>
                </template>
                <template v-slot:header.type>
                  <span>{{ $t("language.type") }}</span>
                </template>
                <template v-slot:header.approver>
                  <span>{{ $t("language.approver") }}</span>
                </template>
                <template v-slot:header.recommender>
                  <span>{{ $t("language.recommender") }}</span>
                </template>
                <template v-slot:header.reason>
                  <span>{{ $t("language.reason") }}</span>
                </template>
                <template v-slot:item.date="{ item }">
                  {{ getDefaultDate(item.date) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        lateinearlyoutapplicationgrid,
                        item.id,
                        'lateinearlyout',
                        'approve'
                      )
                    "
                    color="success"
                    >{{ $t("language.approve") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        lateinearlyoutapplicationgrid,
                        item.id,
                        'lateinearlyout',
                        'reject'
                      )
                    "
                    color="error"
                    >{{ $t("language.reject") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'APPROVED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.approved") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'REJECTED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.rejected") }}</v-chip
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        lateinearlyoutapplicationgrid,
                        item.id,
                        'lateinearlyout',
                        'recommend'
                      )
                    "
                    color="success"
                    >{{ $t("language.recommend") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        lateinearlyoutapplicationgrid,
                        item.id,
                        'lateinearlyout',
                        'decline'
                      )
                    "
                    color="error"
                    >{{ $t("language.decline") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'RECOMMENDED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.recommended") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'DECLINED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.declined") }}</v-chip
                  >
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item
              v-if="$store.getters.settings.enableattendanceapplication"
            >
              <v-data-table
                :headers="attendanceapplicationgrid.headers"
                :items="attendanceapplicationgrid.body"
                :options.sync="attendanceapplicationgrid.options"
                :server-items-length="attendanceapplicationgrid.total"
                :loading="attendanceapplicationgrid.loading"
                :footer-props="grid.footerProps"
                :items-per-page="grid.itemsperpage"
                class="elevation-2"
              >
                <template v-slot:header.person>
                  <span>{{ $t("language.person") }}</span>
                </template>
                <template v-slot:header.fromdate>
                  <span>{{ $t("language.fromdate") }}</span>
                </template>
                <template v-slot:header.todate>
                  <span>{{ $t("language.todate") }}</span>
                </template>
                <template v-slot:header.days>
                  <span>{{ $t("language.days") }}</span>
                </template>
                <template v-slot:header.intime>
                  <span>{{ $t("language.intime") }}</span>
                </template>
                <template v-slot:header.outtime>
                  <span>{{ $t("language.outtime") }}</span>
                </template>
                <template v-slot:header.approver>
                  <span>{{ $t("language.approver") }}</span>
                </template>
                <template v-slot:header.recommender>
                  <span>{{ $t("language.recommender") }}</span>
                </template>
                <template v-slot:header.reason>
                  <span>{{ $t("language.reason") }}</span>
                </template>
                <template v-slot:item.fromdate="{ item }">
                  {{ getDefaultDate(item.fromdate) }}
                </template>
                <template v-slot:item.todate="{ item }">
                  {{ getDefaultDate(item.todate) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        attendanceapplicationgrid,
                        item.id,
                        'attendance',
                        'approve'
                      )
                    "
                    color="success"
                    >{{ $t("language.approve") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'APPROVALPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        attendanceapplicationgrid,
                        item.id,
                        'attendance',
                        'reject'
                      )
                    "
                    color="error"
                    >{{ $t("language.reject") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'APPROVED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.approved") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'REJECTED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.rejected") }}</v-chip
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        attendanceapplicationgrid,
                        item.id,
                        'attendance',
                        'recommend'
                      )
                    "
                    color="success"
                    >{{ $t("language.recommend") }}</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'RECOMMENDATIONPENDING'"
                    text
                    x-small
                    @click="
                      processItem(
                        attendanceapplicationgrid,
                        item.id,
                        'attendance',
                        'decline'
                      )
                    "
                    color="error"
                    >{{ $t("language.decline") }}</v-btn
                  >
                  <v-chip
                    v-if="item.status == 'RECOMMENDED'"
                    small
                    color="success"
                    text-color="white"
                    >{{ $t("language.recommended") }}</v-chip
                  >
                  <v-chip
                    v-if="item.status == 'DECLINED'"
                    small
                    color="error"
                    text-color="white"
                    >{{ $t("language.declined") }}</v-chip
                  >
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import commonservice from "../../shared/common.service";
import Base from "../../shared/Base.vue";
export default {
  name: "inboxview",
  extends: Base,
  data() {
    return {
      leaveapplicationgrid: {
        url: "client/inbox/leaves",
        options: {},
        total: 0,
        body: [],
        headers: [
          { value: "person" },
          { value: "fromdate" },
          { value: "todate" },
          { value: "days" },
          { value: "approver" },
          { value: "recommender" },
          { value: "reason" },
          { value: "action", sortable: false },
        ],
        loading: false,
      },
      officialvisitapplicationgrid: {
        url: "client/inbox/officialvisits",
        options: {},
        total: 0,
        body: [],
        headers: [
          { value: "person" },
          { value: "fromdate" },
          { value: "todate" },
          { value: "days" },
          { value: "approver" },
          { value: "recommender" },
          { value: "reason" },
          { value: "place" },
          { value: "action", sortable: false },
        ],
        loading: false,
      },
      lateinearlyoutapplicationgrid: {
        url: "client/inbox/lateinearlyouts",
        options: {},
        total: 0,
        body: [],
        headers: [
          { value: "person" },
          { value: "date" },
          { value: "approver" },
          { value: "recommender" },
          { value: "reason" },
          { value: "action", sortable: false },
        ],
        loading: false,
      },
      attendanceapplicationgrid: {
        url: "client/inbox/attendances",
        options: {},
        total: 0,
        body: [],
        headers: [
          { value: "person" },
          { value: "fromdate" },
          { value: "todate" },
          { value: "days" },
          { value: "intime" },
          { value: "outtime" },
          { value: "approver" },
          { value: "recommender" },
          { value: "reason" },
          { value: "action", sortable: false },
        ],
        loading: false,
      },
    };
  },
  watch: {
    "leaveapplicationgrid.options": {
      handler() {
        this.loadGrid(this.leaveapplicationgrid);
      },
      deep: true,
    },
    "officialvisitapplicationgrid.options": {
      handler() {
        this.loadGrid(this.officialvisitapplicationgrid);
      },
      deep: true,
    },
    "lateinearlyoutapplicationgrid.options": {
      handler() {
        this.loadGrid(this.lateinearlyoutapplicationgrid);
      },
      deep: true,
    },
    "attendanceapplicationgrid.options": {
      handler() {
        if (this.$store.getters.settings.enableattendanceapplication)
          this.loadGrid(this.attendanceapplicationgrid);
      },
      deep: true,
    },
  },
  methods: {
    gridApiUrl(grid) {
      var param = {
        sortdesc: grid.options.sortDesc,
        page: grid.options.page,
        pagesize: grid.options.itemsPerPage,
        sortBy: grid.options.sortBy,
      };
      let url = grid.url + "?" + commonservice.convertToQueryString(param);
      return url;
    },
    loadGrid(grid) {
      if (grid.headers.length == 0) return;
      grid.loading = true;
      axios
        .get(this.gridApiUrl(grid))
        .then((response) => {
          grid.loading = false;
          grid.body = response.data.rows;
          grid.total = response.data.count;
        })
        .catch(() => {
          grid.loading = false;
        });
    },
    processItem(grid, id, type, action) {
      this.$confirm(
        this.$t("language.processconfirm", {
          action: this.$t("language." + action),
        })
      ).then((res) => {
        if (res) {
          axios
            .get("client/inbox/" + action + "/" + type + "/" + id)
            .then(() => {
              this.loadGrid(grid);
              this.$store.dispatch("updateInboxCount");
              let msg = this.$t("language.successfulprocessed", {
                entity: this.$t("language." + type),
                action: this.$t("language." + action),
              });
              this.$store.dispatch("showSuccessMessage", msg);
            });
        }
      });
    },
  },
};
</script>